import pre from './pre';
import config from './config/index.vue';
import post from './post';
import cart from './cart.vue';
import success from './success.vue';

export default {
  pre,
  components: {
    config,
    cart,
    success,
  },
  post,
};
